import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import com.islamicmedia.site.pages.AccountPage as _com_islamicmedia_site_pages_AccountPage
import com.islamicmedia.site.pages.AdminPage as _com_islamicmedia_site_pages_AdminPage
import com.islamicmedia.site.pages.AppPage as _com_islamicmedia_site_pages_AppPage
import com.islamicmedia.site.pages.BillingCancelPage as _com_islamicmedia_site_pages_BillingCancelPage
import com.islamicmedia.site.pages.BillingCompletePage as _com_islamicmedia_site_pages_BillingCompletePage
import com.islamicmedia.site.pages.CardUpdatedPage as _com_islamicmedia_site_pages_CardUpdatedPage
import com.islamicmedia.site.pages.Index as _com_islamicmedia_site_pages_Index
import com.islamicmedia.site.pages.InvitePage as _com_islamicmedia_site_pages_InvitePage
import com.islamicmedia.site.pages.SeedCatalogPage as _com_islamicmedia_site_pages_SeedCatalogPage
import com.islamicmedia.site.pages.TestPage as _com_islamicmedia_site_pages_TestPage
import com.islamicmedia.site.pages.ThriveCartThankYou as _com_islamicmedia_site_pages_ThriveCartThankYou
import com.islamicmedia.site.pages.UpdateCardPage as _com_islamicmedia_site_pages_UpdateCardPage
import com.islamicmedia.site.pages.isitsafe.AMinecraftMovieReviewPage as _com_islamicmedia_site_pages_isitsafe_AMinecraftMovieReviewPage
import com.islamicmedia.site.pages.isitsafe.ASeriesOfUnfortunateEventsReviewPage as _com_islamicmedia_site_pages_isitsafe_ASeriesOfUnfortunateEventsReviewPage
import com.islamicmedia.site.pages.isitsafe.BlueyReviewPage as _com_islamicmedia_site_pages_isitsafe_BlueyReviewPage
import com.islamicmedia.site.pages.isitsafe.DespicableMe4ReviewPage as _com_islamicmedia_site_pages_isitsafe_DespicableMe4ReviewPage
import com.islamicmedia.site.pages.isitsafe.DiaryOfAWimpyKidReviewPage as _com_islamicmedia_site_pages_isitsafe_DiaryOfAWimpyKidReviewPage
import com.islamicmedia.site.pages.isitsafe.DogManReviewPage as _com_islamicmedia_site_pages_isitsafe_DogManReviewPage
import com.islamicmedia.site.pages.isitsafe.GoatReviewPage as _com_islamicmedia_site_pages_isitsafe_GoatReviewPage
import com.islamicmedia.site.pages.isitsafe.HarryPotterReviewPage as _com_islamicmedia_site_pages_isitsafe_HarryPotterReviewPage
import com.islamicmedia.site.pages.isitsafe.HowToTrainYourDragonReviewPage as _com_islamicmedia_site_pages_isitsafe_HowToTrainYourDragonReviewPage
import com.islamicmedia.site.pages.isitsafe.IceAgeReviewPage as _com_islamicmedia_site_pages_isitsafe_IceAgeReviewPage
import com.islamicmedia.site.pages.isitsafe.IsItSafePage as _com_islamicmedia_site_pages_isitsafe_IsItSafePage
import com.islamicmedia.site.pages.isitsafe.KpopDemonHuntersReviewPage as _com_islamicmedia_site_pages_isitsafe_KpopDemonHuntersReviewPage
import com.islamicmedia.site.pages.isitsafe.KungFuPanda4ReviewPage as _com_islamicmedia_site_pages_isitsafe_KungFuPanda4ReviewPage
import com.islamicmedia.site.pages.isitsafe.LionKingReviewPage as _com_islamicmedia_site_pages_isitsafe_LionKingReviewPage
import com.islamicmedia.site.pages.isitsafe.MinecraftReviewPage as _com_islamicmedia_site_pages_isitsafe_MinecraftReviewPage
import com.islamicmedia.site.pages.isitsafe.Moana2ReviewPage as _com_islamicmedia_site_pages_isitsafe_Moana2ReviewPage
import com.islamicmedia.site.pages.isitsafe.MoanaReviewPage as _com_islamicmedia_site_pages_isitsafe_MoanaReviewPage
import com.islamicmedia.site.pages.isitsafe.MonstersIncReviewPage as _com_islamicmedia_site_pages_isitsafe_MonstersIncReviewPage
import com.islamicmedia.site.pages.isitsafe.PawPatrolReviewPage as _com_islamicmedia_site_pages_isitsafe_PawPatrolReviewPage
import com.islamicmedia.site.pages.isitsafe.RobloxReviewPage as _com_islamicmedia_site_pages_isitsafe_RobloxReviewPage
import com.islamicmedia.site.pages.isitsafe.ToyStory5ReviewPage as _com_islamicmedia_site_pages_isitsafe_ToyStory5ReviewPage
import com.islamicmedia.site.pages.isitsafe.WallEReviewPage as _com_islamicmedia_site_pages_isitsafe_WallEReviewPage
import com.islamicmedia.site.pages.isitsafe.Zootopia2ReviewPage as _com_islamicmedia_site_pages_isitsafe_Zootopia2ReviewPage
import com.islamicmedia.site.pages.isitsafe.ZootopiaReviewPage as _com_islamicmedia_site_pages_isitsafe_ZootopiaReviewPage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Fitrah Filter"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_Index()
        }
        ctx.router.register(
            "/account",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_AccountPage()
        }
        ctx.router.register(
            "/admin",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_AdminPage()
        }
        ctx.router.register(
            "/admin/seed",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_SeedCatalogPage()
        }
        ctx.router.register(
            "/app",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_AppPage()
        }
        ctx.router.register(
            "/billing-cancel",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_BillingCancelPage()
        }
        ctx.router.register(
            "/billing-complete",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_BillingCompletePage()
        }
        ctx.router.register(
            "/card-updated",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_CardUpdatedPage()
        }
        ctx.router.register(
            "/invite",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_InvitePage()
        }
        ctx.router.register(
            "/isitsafe",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_IsItSafePage()
        }
        ctx.router.register(
            "/isitsafe/a-minecraft-movie",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_AMinecraftMovieReviewPage()
        }
        ctx.router.register(
            "/isitsafe/a-series-of-unfortunate-events",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_ASeriesOfUnfortunateEventsReviewPage()
        }
        ctx.router.register(
            "/isitsafe/bluey",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_BlueyReviewPage()
        }
        ctx.router.register(
            "/isitsafe/despicable-me-4",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_DespicableMe4ReviewPage()
        }
        ctx.router.register(
            "/isitsafe/diary-of-a-wimpy-kid",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_DiaryOfAWimpyKidReviewPage()
        }
        ctx.router.register(
            "/isitsafe/dog-man",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_DogManReviewPage()
        }
        ctx.router.register(
            "/isitsafe/goat",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_GoatReviewPage()
        }
        ctx.router.register(
            "/isitsafe/harry-potter",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_HarryPotterReviewPage()
        }
        ctx.router.register(
            "/isitsafe/how-to-train-your-dragon",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_HowToTrainYourDragonReviewPage()
        }
        ctx.router.register(
            "/isitsafe/ice-age",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_IceAgeReviewPage()
        }
        ctx.router.register(
            "/isitsafe/kpop-demon-hunters",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_KpopDemonHuntersReviewPage()
        }
        ctx.router.register(
            "/isitsafe/kung-fu-panda-4",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_KungFuPanda4ReviewPage()
        }
        ctx.router.register(
            "/isitsafe/lion-king",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_LionKingReviewPage()
        }
        ctx.router.register(
            "/isitsafe/minecraft",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_MinecraftReviewPage()
        }
        ctx.router.register(
            "/isitsafe/moana",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_MoanaReviewPage()
        }
        ctx.router.register(
            "/isitsafe/moana-2",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_Moana2ReviewPage()
        }
        ctx.router.register(
            "/isitsafe/monsters-inc",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_MonstersIncReviewPage()
        }
        ctx.router.register(
            "/isitsafe/paw-patrol",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_PawPatrolReviewPage()
        }
        ctx.router.register(
            "/isitsafe/roblox",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_RobloxReviewPage()
        }
        ctx.router.register(
            "/isitsafe/toy-story-5",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_ToyStory5ReviewPage()
        }
        ctx.router.register(
            "/isitsafe/wall-e",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_WallEReviewPage()
        }
        ctx.router.register(
            "/isitsafe/zootopia",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_ZootopiaReviewPage()
        }
        ctx.router.register(
            "/isitsafe/zootopia-2",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_isitsafe_Zootopia2ReviewPage()
        }
        ctx.router.register(
            "/test",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_TestPage()
        }
        ctx.router.register(
            "/thrivecart-thank-you",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_ThriveCartThankYou()
        }
        ctx.router.register(
            "/update-card",
        ) { pageCtx -> 
            _com_islamicmedia_site_pages_UpdateCardPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.islamicmedia.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
